<template>
    <i class="ico-svg-book">
        <svg v-bind="{ width, height }" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.8 17.727c0-.463.403-.838.9-.838h13.5c.995 0 1.8-.75 1.8-1.675V2.648C18 1.26 16.791.135 15.3.135H2.7C1.209.135 0 1.26 0 2.648v15.079c0 1.388 1.209 2.513 2.7 2.513h14.4c.497 0 .9-.376.9-.838 0-.462-.403-.838-.9-.838H2.7c-.497 0-.9-.375-.9-.837z" :fill="color"/>
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconBook',

    props: {
        width: {
            type: Number,
            default: 18,
        },

        height: {
            type: Number,
            default: 21,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
